export default __webpack_public_path__ + "media/images/react_icons/bank-card-1a143ea58f9bff014bc8767fa9f0160d.svg";